import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { debounceTime, fromEvent, Subscription } from "rxjs";
import { FilterService } from "src/app/services/filter.service";
import { DeviceDetectionService } from "src/app/services/detectipad.service";
import { WidgetService } from "src/app/services/widget.service";
import { ActivatedRoute } from "@angular/router";
import { NavigationService } from "src/app/services/navigation.service";
import { CdkMenuTrigger } from '@angular/cdk/menu';
import { MatDatepicker } from '@angular/material/datepicker';
import { HttpClient } from "@angular/common/http";
import { ApiService } from "src/app/services/api.service";
import _ from "lodash";
import moment from "moment";

@Component({
  selector: "app-filter-badges",
  templateUrl: "./filter-badges.component.html",
  styleUrls: ["./filter-badges.component.scss"],
})
export class FilterBadgesComponent implements OnInit, OnDestroy, AfterViewChecked {
  static key = 100301;
  availableYears:any = [];
  initializeYears() {
    const currentYear = new Date().getFullYear();
    const yearRange = 5; // You can adjust this range
    this.availableYears = Array.from(
      { length: yearRange },
      (_, i) => currentYear - 2 + i // Generates a range of years around the current year
    );
  }
  handleRangeSelection(range: { startMonth: string; endMonth: string }) {
    console.log('Selected Range:', range);
    alert(`Selected Range: ${range.startMonth} to ${range.endMonth}`);
  }
  @Input("config") config: any = {};
  @Input("item") item: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @Input("height") height: any = {};

  xMark = "x_mark";
  label = "";
  reqSubcription: Subscription[] = [];
  localData: any = [];
  optionsData: any = [];
  selectedData:any;
  selectedType:any;
  filterType:any;
  DateConfig:any;
  badgesDefault:any;
  flagOnSide = false;
  dynItemWidth = 'auto';
  dashboardKey:any;
  
  selectedValue: any[] = [];
  isMultiSelect: boolean = true;
  searchTerm = '';
  originalOptionsData: any[] = [];
  fieldKey:any;
  field:any;
  isAddChecked: boolean = false; // Tracks "Add current selection to filter"
  isGrouped = false;
  groupByKey:any = null;
  private needsCheckboxUpdate = false;
  groupedOptionsCache: any[] = [];

  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent!: ElementRef<any>;
  @ViewChild("filterBadgesDiv", { read: ElementRef }) filterBadgesDiv!: ElementRef<any>;
  @ViewChild('menuTrigger') menuTrigger!: CdkMenuTrigger;

  private div!: HTMLElement;
  
  get isDashboardKeyExcluded(): boolean {
    return [20250203032505,20250204033031,20250218045937,20250304063130].includes(this.dashboardKey);
  }

  constructor(
    public filterService: FilterService, 
    public deviceDetectionService: DeviceDetectionService,
    private cdr: ChangeDetectorRef,
    private widgetService: WidgetService,
    public route: ActivatedRoute,
    private navigationService: NavigationService,
    private httpClient: HttpClient,
    private apiService: ApiService
  ) {
    this.initializeYears();
    this.route.params.subscribe((p: any) => {
      this.route.queryParams.subscribe((params:any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
      });
    });
  };

  public scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 150), behavior: 'smooth' });
  }

  public scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 150), behavior: 'smooth' });
  }

  scrollClickIcon() {
    if(!this.widgetsContent?.nativeElement) return false;
    const scrollContent = this.widgetsContent.nativeElement;
    return scrollContent.scrollWidth > scrollContent.clientWidth;
  }
  
  ngOnInit(): void {
    this.label = this.item.config["report_heading"];

    // this.badgesDefault =[...this.filterService.badges]
    // this.cdr.detectChanges();
  }

  checkData() {
    
    let filterData = this.filterService.badges.filter(
      (flr: any) => flr.path == "multiSelection"
    );
    if (filterData) {
      let findData = filterData.map((fnd: any) => fnd.value != fnd.length);
      if (findData) {
        this.filterService.badgeCheck = true;
      } else {
        this.filterService.badgeCheck = false;
      }
    }
  }

  resetFIlter() {
    this.filterService.bufferSlider.next(false);
    this.filterService.resetFilter();
  }
  
  isNewMultiSelection = false;
  userCanSelect:any;
  decomm_flag=false;
  decommReplaceName:any;
  decommColor:any;
  decommlabel:any;
  decommTooltip:any;
  isRootSqBadge = false;

  // Process data for grouping
  processGroupedData(data: any[], isGrouped: string, groupLabelProp?: string) {
    if (isGrouped) {
    
      this.groupByKey = groupLabelProp;
      const ungroupedItems = data.filter(item => !item[this.groupByKey]);
      const groupedItems = data.filter(item => item[this.groupByKey]);
      return [...ungroupedItems, ...groupedItems];
    }
    this.isGrouped = false;
    return data;
  }
  
  selectedValues(event: any) {
    this.isGrouped = event.isGrouped;
    // debugger
    
    let fndField = this.filterService.globalFilterFields.find((f:any) => f.key == event.key);
    if(fndField) {
      let cnfg = fndField.templateOptions;
      this.decomm_flag = cnfg.decomm_flag == 'yes' ? true : false;
      this.decommReplaceName = cnfg.decommReplaceName || 'decomm_flg';
      this.decommColor = cnfg.decommColor || '#c04a36';
      this.decommlabel = cnfg.decommlabel || 'Decomm.';
      this.decommTooltip = cnfg.decommTooltip || 'Decommissioned';
      this.isRootSqBadge = cnfg.isRootSqBadge || false;
    }

    this.searchTerm = '';
    this.fieldKey = event.key;
    this.field = event.field;
    this.isNewMultiSelection = this.field?.type == "new-multi-select" ? true : false;
    let opt = this.field?.templateOptions || {};
    this.userCanSelect = opt?.userCanSelect || 100;
    
    // dynamiclly changing the single and multi select
    this.isMultiSelect = (event.path == "singleSelection" || event.path == "quarterSelection") ? false : true;
    this.filterType=event.path
    this.selectedType=event.selectedType;
    // debugger
    this.isAddChecked=false;
    // this.localData = [];
    // this.optionsData = [];
    // this.selectedValue = [];

     // list of selected values
    if (event.selectedData?.length >= 1) {
      this.localData = event.selectedData
        .filter((item: Record<string, any>) => item[event.labelProp])
        .map((item: Record<string, any>) => ({
          key: event.labelProp,
          value: item[event.labelProp],
          ...item
        }));
    } else {
      if (['quarter_select', 'date_range', 'quarter_range_select', 'time_date', 'time_single_date', 'from_date', 'to_date','time_cycle',"initiation_date"].includes(event.key)||['formlyDateRangeSelection','formlyYearlySelection'].includes(event.path)) {

        this.DateConfig = event;
        this.selectedData = event.selectedData;
        return;

        // this.localData = [];
      } else if (event.selectedData?.[event.labelProp]) {
        this.localData = [
          {
            key: event.labelProp,
            value: event.selectedData[event.labelProp],
            ...event.selectedData
            
          },
        ];
      }
    }

    // list of options
    if (event?.option) {
      let mappedData = event.option
        .filter((item: Record<string, any>) => item[event.labelProp])
        .map((item: Record<string, any>) => ({
          key: event.labelProp,
          value: item[event.labelProp],
          ...item
        }));
      
      // Process data for grouping if applicable (get groupLabelProp from event)
      this.optionsData = this.processGroupedData(mappedData, event.isGrouped, event.groupLabelProp);
    } else {
      this.optionsData = [];
    }

    this.originalOptionsData = this.optionsData;
    
    // Update grouped cache after optionsData is set
    if (this.isGrouped) {
      this.getGroupedOptions();
    }
    
    this.selectedValue = [...this.localData];
    
    // Trigger checkbox update if grouped and has selections
    if (this.isGrouped && this.selectedValue.length > 0) {
      this.needsCheckboxUpdate = true;
      this.cdr.detectChanges();
    }
  }


  applyFilterBatch() {
    
    let data = '';
    this.selectedValue.forEach((element: any, idx:any) => {
      data += element[this.fieldKey] + ((this.selectedValue.length-1 == idx) ? '' : '|,|');
    })

    let ab = {
      key: this.fieldKey,
      value: data,
      allNewData: this.originalOptionsData,
      selectAll: this.areAllSelected() 
    }

    this.filterService.intractiveFilter.next(ab);
  }
  //Selected value for single and multi select
  toggleSelection(item: any,index:any, event?:any): void {
    if(event)
      event.stopPropagation();

    if (this.isMultiSelect) {
      const itemId = this.getItemIdentifier(item);
      const selectedIndex = this.selectedValue.findIndex(
        (selected: any) => this.getItemIdentifier(selected) === itemId
      );
  
      if (selectedIndex > -1) {
        this.selectedValue.splice(selectedIndex, 1);
      } else {
        this.selectedValue.push(item);
      }
      
      // Create new array reference to trigger change detection
      this.selectedValue = [...this.selectedValue];
      
      // Mark that group checkboxes need visual update
      if (this.isGrouped) {
        this.needsCheckboxUpdate = true;
      }
      
      // Trigger change detection
      this.cdr.detectChanges();
      
      return;
    }
  
    const itemId = this.getItemIdentifier(item);
    const isSelected = !!this.selectedValue.find(
        (selected: any) => this.getItemIdentifier(selected) === itemId
    );

    // Prevent deselecting the last item in single-select mode
    if (isSelected && this.selectedValue.length === 1) {
      return; // Do nothing if it's the last selected item
    }

    this.selectedValue = (isSelected ? [ ] : [item]); 
    if (!this.isMultiSelect) {
      this.applyFilterBatch();
    } 
  }
  
  

  // Toggle checkbox selection
  toggleCheckbox(event: Event, item: any): void {
    event.stopPropagation();
    const itemId = this.getItemIdentifier(item);
    const isSelected = !!this.selectedValue.find(
      (selected: any) => this.getItemIdentifier(selected) === itemId
    );
 
    if ( !this.isMultiSelect && isSelected && this.selectedValue.length == 1) {
      event.preventDefault();
      return; // Do nothing if it's the last selected item
    }
    this.toggleSelection(item, this.optionsData.indexOf(item));
  }

  applyDateFilter(event:any,type:any){
    this.selectedData=type=="quarter"?{from_date:this.getQuarterStartDate(event.from_date),to_date:this.getQuarterEndDate(event.to_date)} : event
    let ab = {
      key: this.fieldKey,
      value: event,
      type: this.selectedType
    }
    this.filterService.intractiveFilter.next(ab);
  }

  // Apply filter logic  'include' | 'exclude'
  applyFilter(type: 'include' | 'exclude' | 'date'): void {
    // this.selectedValue=[...this.selectedValue]
    if (type === 'include') {
      if(!this.isAddChecked) {
        const included =  this.optionsData.filter(
          (item: any) => this.selectedValue.some(
            (selectedItem: any) => this.getItemIdentifier(selectedItem) === this.getItemIdentifier(item)
          )
        );
        this.selectedValue = included;
      }
      // Filter logic for Include
      // alert('Included: ' + this.selectedValue.map(val => val.value).join(', '));
      // console.log('Included:', this.selectedValue);
    } else if (type === 'exclude') {
      // Filter logic for Exclude
      const excluded =  this.optionsData.filter(
        (item: any) => !this.selectedValue.some(
          (selectedItem: any) => this.getItemIdentifier(selectedItem) === this.getItemIdentifier(item)
        )
      );
      this.selectedValue = excluded;
      console.log('Excluded:', excluded);
      // alert('Excluded: ' + excluded.map((val:any) => val.value).join(', '));
    }
   this.applyFilterBatch();
  }


  isSelected(option: any): boolean {
    const optionId = this.getItemIdentifier(option);
    return this.selectedValue.some(
      (item: any) => this.getItemIdentifier(item) === optionId
    );
  }


   // Search Functionality
   filterOptions(): void {
    if (this.searchTerm.trim() === '') {
      // Reset optionsData to the original array when the search term is cleared
      this.optionsData = [...this.originalOptionsData];
    } else {
      // Filter optionsData based on the search term
      this.optionsData = this.originalOptionsData.filter((option: any) =>
        option.value?.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
    
    // Update grouped cache
    if (this.isGrouped) {
      this.getGroupedOptions();
      this.needsCheckboxUpdate = true;
    }
  }
 // Toggles Select All/Deselect All
toggleSelectAll(event:any,value?:boolean,filterapply?:boolean): void {
  event.stopPropagation();
  const shouldSelectAll = value || !this.areAllSelected(); // Check if we need to select all or deselect all

  if (shouldSelectAll) {
    // Select all: add any unselected options to selectedValue
    const newSelections: any[] = [];
    this.optionsData.forEach((option: any) => {
      if (!this.isSelected(option)) {
        newSelections.push(option);
      }
    });
    this.selectedValue = [...this.selectedValue, ...newSelections];
  } else {
    // Deselect all: remove all options from selectedValue
    this.selectedValue = this.selectedValue.filter((selected: any) =>
      !this.optionsData.some((option: any) => 
        this.getItemIdentifier(option) === this.getItemIdentifier(selected)
      )
    );
  }
  
  // Mark that group checkboxes need visual update
  if (this.isGrouped) {
    this.needsCheckboxUpdate = true;
  }
  
  // Trigger change detection
  this.cdr.detectChanges();
  
  if(filterapply){
    this.applyFilterBatch();
  }
}

// Determines if all options are selected
areAllSelected(): boolean {
  return this.optionsData.every((option: any) => this.isSelected(option));
}

  onMenuClosed() {
    // this.searchTerm = '';
    // console.log('Menu has been closed');
  }
 selectAddClick(): void {
    this.isAddChecked = !this.isAddChecked;

    // Add or remove previous selections based on checkbox state
    const previousSelections = this.localData//.filter((item:any) => !this.optionsData.includes(item));
    if (this.isAddChecked) {
      this.selectedValue = [...new Set([...previousSelections, ...this.selectedValue])];
    } else {
      this.selectedValue = this.selectedValue.filter(item => this.optionsData.includes(item));
    }
  }

  generateQuartersForRange(startYear: number, endYear: number): string[] {
    const quarters: string[] = [];
    for (let year = startYear; year <= endYear; year++) {
      quarters.push(...["Q1", "Q2", "Q3", "Q4"].map((q) => `${q} ${year}`));
    }
    return quarters;
  }
  // Get the start date of the selected quarter
  getQuarterStartDate(quarter: string): Date {
    const [q, year] = quarter.split(" ");
    const dates: any = { Q1: "01/01", Q2: "04/01", Q3: "07/01", Q4: "10/01" };
    return new Date(`${dates[q]}/${year}`);
  }

  // Get the end date of the selected quarter
  getQuarterEndDate(quarter: string): Date {
    const [q, year] = quarter.split(" ");
    const dates: any = { Q1: "03/31", Q2: "06/30", Q3: "09/30", Q4: "12/31" };
    return new Date(`${dates[q]}/${year}`);
  }

  findDateColor(badge:any) {
    // debugger
    if(badge.path=='formlyYearlySelection') {
      if(this.filterService.allOptionData['formly_yearly_selection']?.[badge?.key]) {
        const date = this.filterService.allOptionData['formly_yearly_selection']?.[badge?.key];
        if(date.selectedDate != new Date(badge?.value).getFullYear()) {
            return '#FF9A3D';
          }
      }

      return '';
    } else if(badge.path=='formlyDateRangeSelection') {
      if(this.filterService.allOptionData['formly_date']?.[badge?.key]) {
        const date = this.filterService.allOptionData['formly_date']?.[badge?.key];
        if(new Date(date.start).getTime() != new Date(badge?.value).getTime() || 
          new Date(date.end).getTime() != new Date(badge?.length).getTime()) {
            return '#FF9A3D';
          }
      }

      return '';
    } else if (badge.path=='quarterSelection' || badge.path=='quarterRangeSelection') {

      if(this.filterService.defaultDateSelection) {
        let start = this.filterService.defaultDateSelection?.from_date
        let end = this.filterService.defaultDateSelection?.to_date
        let from_dt = badge?.selectedData?.from_date;
        let to_dt = badge?.selectedData?.to_date;
        if(from_dt != start || 
          to_dt != end) {
            return '#FF9A3D';
          }
      }

      return '';
    } else {
      if(this.filterService.defaultDateSelection) {
        let start = this.filterService.defaultDateSelection?.from_date
        let end = this.filterService.defaultDateSelection?.to_date
        let format_From = moment(start).format('MM/DD/YY') 
        let format_To = moment(end).format('MM/DD/YY') 

        if(format_From != badge?.value || 
          format_To != badge?.length) {
            return '#FF9A3D';
          }
      }

      return '';
    }
  }

  filterServerOptions($event?:any) {

    let opt = this.field?.templateOptions || {};
    let dataSourceUrl = opt?.dataSourceUrl

    if (this.searchTerm && this.searchTerm.length>=4 && dataSourceUrl) {
      let query:any = this.filterService.serverSideVaribles[this.field.key];
      if(this.fieldKey == "payer_dim_key") {
        query['payer_search'] = this.searchTerm;
      } else if (this.fieldKey == "city_name_dim_key") {
        query['city_search'] = this.searchTerm;
      } else {
        query['prescriber_search'] = this.searchTerm;
      }

      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${dataSourceUrl}`, query).subscribe((data: any) => {
          let localData = data
            .filter((item: Record<string, any>) => item[opt.labelProp])
            .map((item: Record<string, any>) => ({
              key: opt.labelProp,
              value: item[opt.labelProp],
              ...item
          }));
          this.findtheUniqueFrmSearch(localData);
          // this.optionsData = localData ? [...localData] : [];

        }, err => {
          // this.optionsData = [];
        })
      )
    } else {
      this.filterOptions();
    }
  }
  
  storedSearchData:any = [];
  
  // Get grouped options for display
  getGroupedOptions() {
    if (!this.isGrouped) {
      this.groupedOptionsCache = [];
      return this.groupedOptionsCache;
    }
    
    const groups: any = {};
    const ungrouped: any[] = [];
    
    this.optionsData.forEach((item: any) => {
      const groupValue = item[this.groupByKey];
      if (!groupValue) {
        ungrouped.push(item);
      } else {
        if (!groups[groupValue]) {
          groups[groupValue] = [];
        }
        groups[groupValue].push(item);
      }
    });
    
    const result = [];
    
    // Add ungrouped items first
    if (ungrouped.length > 0) {
      result.push({ groupName: null, items: ungrouped });
    }
    
    // Add grouped items
    Object.keys(groups).forEach(groupName => {
      result.push({ groupName, items: groups[groupName] });
    });
    
    this.groupedOptionsCache = result;
    return this.groupedOptionsCache;
  }

  // Get unique identifier for an item
  getItemIdentifier(item: any): any {
    // Use the field key (e.g., 'source_key') if available, otherwise fall back to key___value combination
      return `${item.key}___${item.value}`;
  }

  // Get items by group name
  getItemsByGroupName(groupName: string): any[] {
    return this.optionsData.filter((item: any) => {
      const itemGroupValue = item[this.groupByKey];
      if (!groupName) {
        return !itemGroupValue || itemGroupValue === null || itemGroupValue === undefined;
      }
      return itemGroupValue === groupName;
    });
  }

  // Check if all items in a group are selected
  isGroupSelected(groupName: string): boolean {
    const groupItems = this.getItemsByGroupName(groupName);
    if (groupItems.length === 0) return false;
    
    return groupItems.every((item: any) => 
      this.selectedValue.some((selected: any) => 
        this.getItemIdentifier(selected) === this.getItemIdentifier(item)
      )
    );
  }

  // Check if some (but not all) items in a group are selected
  isGroupIndeterminate(groupName: string): boolean {
    const groupItems = this.getItemsByGroupName(groupName);
    if (groupItems.length === 0) return false;
    
    const selectedCount = groupItems.filter((item: any) => 
      this.selectedValue.some((selected: any) => 
        this.getItemIdentifier(selected) === this.getItemIdentifier(item)
      )
    ).length;
    
    return selectedCount > 0 && selectedCount < groupItems.length;
  }

  // Get checkbox state for group
  getGroupCheckboxState(groupName: string): 'checked' | 'indeterminate' | 'unchecked' {
    const groupItems = this.getItemsByGroupName(groupName);
    if (groupItems.length === 0) return 'unchecked';
    
    const selectedCount = groupItems.filter((item: any) => 
      this.selectedValue.some((selected: any) => 
        this.getItemIdentifier(selected) === this.getItemIdentifier(item)
      )
    ).length;
    
    if (selectedCount === 0) return 'unchecked';
    if (selectedCount === groupItems.length) return 'checked';
    return 'indeterminate';
  }

  // Handle click on group div
  onGroupDivClick(groupName: string, event: any): void {
    event.stopPropagation();
    event.preventDefault();
    
    this.toggleGroupSelection(groupName, event);
  }

  // Toggle group selection
  toggleGroupSelection(groupName: string, event: any): void {
    event.stopPropagation();
    
    const groupItems = this.getItemsByGroupName(groupName);
    const isSelected = this.isGroupSelected(groupName);
    
    if (isSelected) {
      // Deselect all items in the group
      this.selectedValue = this.selectedValue.filter((selected: any) => 
        !groupItems.some((item: any) => 
          this.getItemIdentifier(item) === this.getItemIdentifier(selected)
        )
      );
    } else {
      // Select all items in the group that aren't already selected
      groupItems.forEach((item: any) => {
        const isAlreadySelected = this.selectedValue.some((selected: any) => 
          this.getItemIdentifier(selected) === this.getItemIdentifier(item)
        );
        if (!isAlreadySelected) {
          this.selectedValue.push(item);
        }
      });
    }
    
    // Create new array reference to trigger change detection
    this.selectedValue = [...this.selectedValue];
    
    // Mark that checkboxes need visual update
    this.needsCheckboxUpdate = true;
    
    // Trigger change detection
    this.cdr.detectChanges();
  }

  // Lifecycle hook to update checkbox states after view is checked
  ngAfterViewChecked(): void {
    if (this.needsCheckboxUpdate && this.isGrouped) {
      this.updateGroupCheckboxStates();
      this.needsCheckboxUpdate = false;
    }
  }

  // Update all group checkbox indeterminate states
  updateGroupCheckboxStates(): void {
    if (!this.optionsData || this.optionsData.length === 0) return;
    
    // Get all unique group values
    const groupValues = new Set<string>();
    this.optionsData.forEach((item: any) => {
      const groupValue = item[this.groupByKey] || '';
      groupValues.add(groupValue);
    });
    
    // Update each group checkbox
    groupValues.forEach(groupValue => {
      if (groupValue) { // Skip ungrouped items
        const state = this.getGroupCheckboxState(groupValue);
        const checkboxId = `group-checkbox-${groupValue}`;
        const checkbox = document.getElementById(checkboxId) as HTMLInputElement;
        
        if (checkbox) {
          checkbox.indeterminate = (state === 'indeterminate');
        }
      }
    });
  }

  findtheUniqueFrmSearch(data: any[]) {
    let opt = this.field.templateOptions || {};
    // this.optionsData = [...data]
    
    const combined = _.concat(this.storedSearchData, data);
    this.storedSearchData = _.uniqBy(combined, opt.valueProp);
    let originalOptionsData = _.concat(this.originalOptionsData, this.storedSearchData);
    this.originalOptionsData = _.uniqBy(originalOptionsData, opt.valueProp);
    this.optionsData = this.originalOptionsData;
    this.filterOptions();
  }
  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
